import PropTypes from 'prop-types';

import permissionType from "types/permission/permission.type";

export default PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    addedAt: PropTypes.string,
    addedBy: PropTypes.string
})